import React, { useState, useEffect } from "react";
import { urldata2 } from "../../urldata";
import salescatalog from "./salescatalog.pdf";
import "./style.less";
import axios from "axios";
const Content = () => {
  const [pdfData, setPdfData] = useState("");
  let liveUrl = "https://hosindia.com/api/";
  let testUrl = "https://api.laxmihos.com/api/";
  let liveUrlWithoutSlash = "https://hosindia.com/api";
  // console.log(pdfData)
  useEffect(() => {
    // let url = new URL('https://api.laxmihos.com/api/' + "admin/getpdf");
    let url = new URL(liveUrl + "admin/getpdf");
    axios({
      method: "get",
      url: url,
      withCredentials: true,
    })
      .then((response) => {
        setPdfData(response.data.data[0]);
        // setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        // setLoading(false);
        // showToast("danger");
      });
  }, []);

  return (
    <div className="iframepdf">
      <iframe
        className=""
        id="areYouRiskReadyVideo"
        width="100%"
        height="100vh"
        src={pdfData.pdfupload ? liveUrlWithoutSlash + pdfData.pdfupload : ""}
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
    </div>
  );
};

export default Content;

// src={pdfData.pdfupload ? 'https://api.laxmihos.com/api/'+pdfData.pdfupload: ''}
